import { createContext, useContext } from 'react';
import { AppDispatch } from 'redux';
import { makeDmmCookieInteractions } from './dmm';
import { makeEngooCookieInteractions } from './engoo';
import { fold, setCookie, clearCookie, CookieMismatchError, CookieContext } from './cookie';
import { pipe } from 'fp-ts/lib/pipeable';
import { EntityFields } from 'app/types/entity';
import { IBrandDomain } from 'app/constants/schemas/BrandDomain';

export interface ICookieTokenInfo {
  created_at: number;
  expires_in: number;
}

export interface ICookieInteractions {
  cleanCookieData: () => (dispatch: AppDispatch) => void;
  setAuthCookie: (userId: string, token: ICookieTokenInfo) => (dispatch: AppDispatch) => Promise<void>;
  checkAuthCookie: (userId: string) => (dispatch: AppDispatch) => Promise<void>;
  clearSharedCookie: () => void;
}

export {
  setCookie,
  clearCookie,
  CookieMismatchError,
};

export const NoopInteractions: ICookieInteractions = {
  cleanCookieData: () => () => {},
  setAuthCookie: () => async () => {},
  checkAuthCookie: () => async () => {},
  clearSharedCookie: () => {},
};

export interface ICookieContext {
  isFirstParty: boolean;
  isFirstPartyDmm: boolean;
  defaultDomain: EntityFields<IBrandDomain>;
}

export const makeCookieInteractions = (context: ICookieContext) =>
  pipe(
    context.isFirstParty ?
      (context.isFirstPartyDmm ? CookieContext.DMM : CookieContext.ENGOO) : CookieContext.THIRD_PARTY,
    fold<ICookieInteractions>(
      () => makeDmmCookieInteractions(context),
      () => makeEngooCookieInteractions(context),
      () => NoopInteractions,
    ),
  );

const CookieInteractionContext = createContext(NoopInteractions);
export const useCookieInteractions = () => useContext(CookieInteractionContext);
export const ProvideCookieInteractions = CookieInteractionContext.Provider;
